window.addEventListener("beforeunload", () => {
  sessionStorage.setItem("scrollToTop", "true");
});

window.addEventListener("load", () => {
  const bodyElement = document.body;
  const specificClass = 'rfq_product';
  if (bodyElement.classList.contains(specificClass)) {
   if (sessionStorage.getItem("scrollToTop") === "true") {
      sessionStorage.removeItem("scrollToTop");
      window.scrollTo({
        top: 0,
        behavior: "smooth" // Use "auto" if smooth scrolling is unnecessary
      });
    }
  }
  const requestForQuoteBtn = document.querySelector(".product-request-for-quote");
  const form = document.querySelector("#T6WZoYp5o4orGXKgoGJmnA");

  let isFormOpen = false;

  if (form) {
    form.style.display = "none";
  }
  
  if (requestForQuoteBtn) {
    requestForQuoteBtn.addEventListener("click", () => {
      if (isFormOpen) {
        isFormOpen = false;
        window.location.reload();
        form.style.display = "none";
        styleButton(requestForQuoteBtn, "primary");
      } else {
        isFormOpen = true;
        form.style.display = "block";
        styleButton(requestForQuoteBtn, "secondary");
      }
    }); 
  }
});

function styleButton(button, type) {
  if (type === "primary") {
    button.textContent = "Request for Quote";
    button.style.backgroundColor = "#000";
    button.style.color = "#fff";
    button.style.marginTop = "0";
    button.style.textDecoration = "unset";
    button.style.textUnderlineOffset = "0px";
  } else if (type === "secondary") {
    button.textContent = "Close Form";
    button.style.backgroundColor = "#fff";
    button.style.color = "#000";
    button.style.marginTop = "-30px";
    button.style.textDecoration = "underline";
    button.style.textUnderlineOffset = "6px";
  }
}